/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import DropDown from 'app/components/common/DropDown.jsx';
import FilterItem from 'app/components/DropDownItems/FilterItem.jsx';
import SearchControl from 'app/components/common/SearchControl.jsx';
import { Breakpoint } from 'react-socks';

class SubaccountHeader extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showRouteFilter: false,
			inputContent: '',
			filterName: '',
        };

        this.createNewUser = this.createNewUser.bind(this);
        this.inputHandler = this.inputHandler.bind(this);
    }

    createNewUser(e){
        let constants = this.props.app.config.constants;

        if (this.props.isFreeUser() && this.props.hostPage === 'users') {
            this.props.showUpgradeModal(this.props.closeAllModals, 'users', null, 'team_banner');
        } else if (this.props.user.perms.resources.usersAvailable <= 0 && this.props.hostPage === 'users') {
            this.props.showUpgradeModal(this.props.closeAllModals, 'usersLimit', null, 'team_limit');
        } else if (this.props.user.perms.resources.clientsAvailable <= 0 && this.props.hostPage === 'clients') {
            this.props.showUpgradeModal(this.props.closeAllModals, 'clientSeatLimit', null, 'client_limit');
        } else {
            let page = (this.props.hostPage === 'users') ? 'team' : 'clients';
            if (this.props.newSubaccountCallback) {
                this.props.newSubaccountCallback(e);
            }
            this.props.router.navigate('/people/' + page + '/new');
        }
	}

	inputHandler(e, value){

        this.props.searchHandler(e, value);

	}

    render() {
        let labels = {
            searchPlaceholder: 'Search Team Members',
            newButtonLabel: 'Add Team Member'
        };

        if (this.props.hostPage === 'clients') {
            labels = {
                searchPlaceholder: 'Search Clients',
                newButtonLabel: 'Add Client'
            };
        }

        return (
            <div>
                <Breakpoint desktop only>
        			<div className="control-bar">
        				<div className="control search subaccounts">
        					<SearchControl
                                {...this.props}
                                changeHandler={this.inputHandler}
                    			extraClasses=""
                    			placeholder={labels.searchPlaceholder}
                    			wrapperClass="header-control"
                                defaultFocus={false} />
        				</div>
        				<div className="control connect subaccounts" onClick={this.createNewUser} role="button" aria-label={labels.newButtonLabel}>
                            <div className="control-wrapper">
                                <span className="va-helper"></span>
            					<div className="control-icon">
            						<i className="fa fa-plus-square new-icon"></i>
            					</div>
            					<div className="control-label">{labels.newButtonLabel}</div>
                            </div>
        				</div>
        			</div>
                </Breakpoint>
                <Breakpoint mobile only>
                    <div className="mobile-control-bar">
                        <div className="control new subuser" onClick={this.createNewUser} role="button" aria-label={labels.newButtonLabel}>
                            <span className="va-helper"></span>
							<i className="fa fa-plus-square new-icon"></i> {labels.newButtonLabel}
        				</div>
                        <div className="control search subaccounts">
        					<SearchControl
                                {...this.props}
                                changeHandler={this.inputHandler}
                    			extraClasses=""
                    			placeholder={labels.searchPlaceholder}
                    			wrapperClass="header-control mobile"
                                defaultFocus={false}
                                fieldIcon="icon ion-search" />
        				</div>
                    </div>
                </Breakpoint>
            </div>
		);
	}
};

SubaccountHeader.displayName = "SubaccountHeader";

SubaccountHeader.propTypes = {
    searchHandler: PropTypes.func,
    userPerms: PropTypes.object,
    recordPath: PropTypes.func,
    setModal: PropTypes.func,
    trialEligible: PropTypes.bool,
    hostPage: PropTypes.string,
    newSubaccountCallback: PropTypes.func
};

SubaccountHeader.defaultProps = {
    searchHandler: null,
    userPerms: {},
    recordPath: null,
    setModal: null,
    trialEligible: false,
    hostPage: 'users',
    newSubaccountCallback: () => {}
};

export default SubaccountHeader;
